// 信息化建设
<template>
  <div class="main">
    <div class="banana">
      <img src="../assets/img/banner/informage.png" alt />
    </div>
    <div class="center">
      <div class="nav">
        <p>
          当前位置：
          <span @click="shouye" class="navvv">首页</span> > 项目信息化建设
        </p>
      </div>
      <h1 class="title">项目信息化建设</h1>
      <p
        class="jianjie"
      >以工程项目为服务对象，通过云计算、大数据、物联网、人工智能、移动智能终端和5G等信息技术，为企业提供投标展示方案、图纸会审、工程量的统计、施工模拟、可视化交底、施工节点分析、综合管线碰撞检测、建筑物全生命周期信息化模型等BIM、智慧工地方面的咨询服务。</p>

      <div class="msg">
        <div class="leftMsg">
          <div class="one"></div>
          <div class="two"></div>
          <div class="three"></div>
          <div class="four"></div>
          <div class="five"></div>
        </div>
        <div class="rightMsg">
          <div class="msone">
            <h2>投标阶段信息化</h2>
            <p>利用BIM、计算机图形学与动画技术等信息技术，为客户提供投标项目的主要施工方案、关键施工部位可视化模拟方案，比较直观、形象地展示给建设单位，充分体现客户的施工经验和技术能力，助力客户赢得投标工程。</p>
          </div>
          <div class="mstwo">
            <h2>建造过程中信息化</h2>
            <p>利用BIM、4D技术、虚拟仿真技术、计算机图形学与动画技术、移动互联网、大数据等信息技术，对拟建工程的各分部分项工程、施工工序、机械设备、现场布置等随进度的变化进行动态虚拟模拟。针对各专业工程不协调、工作量不准确、施工进度变化、综合管线碰撞等问题，以及装配式部品部件的加工安装、信息化样板、可视化技术交底、质量安全绿色施工信息化管控、场地布置等方面提供咨询服务。</p>
          </div>
          <div class="msthree">
            <h2>运行维护阶段信息化</h2>
            <p>利用BIM、物联网、传感器等技术，采集建筑物建造过程中的历史数据，实现实物与信息模型同步，为后期运营维护提供真实、客观、有效的数据。</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {},
  data() {
    return {};
  },
  methods: {
    shouye() {
      this.$router.replace("/");
    },
  },
  components: {},
};
</script>

<style scoped lang="less">
.main {
  width: 100%;
  font-size: 16px;
  .banana {
    width: 100%;
    // background: url("../assets/img/banner/informage.png") center no-repeat;
    // background-size: cover;
    img {
      width: 100%;
      height: 100%;
    }
  }
  .center {
    width: 1160px;
    // padding: 0px 3.6px;
    margin: 0 auto;
    box-sizing: border-box;
    overflow: hidden;
    .nav {
      width: 100%;
      border-bottom: 1px solid #a0a0a0;
      opacity: 1;
      font-size: 12px;
      font-family: Microsoft YaHei Regular, Microsoft YaHei Regular-Regular;
      font-weight: 400;
      text-align: justifyLeft;
      color: #666666;
      line-height: 36px;
      margin-bottom: 50px;
    }
    .title {
      opacity: 1;
      font-size: 35px;
      font-family: Microsoft YaHei Bold, Microsoft YaHei Bold-Bold;
      font-weight: 700;
      text-align: center;
      color: #4279db;
    }
    .jianjie {
      opacity: 1;
      font-size: 16px;
      font-family: Microsoft YaHei Regular, Microsoft YaHei Regular-Regular;
      // font-weight: bolder;
      line-height: 30px;
      text-align: left;
      color: #231815;
      text-indent: 2em;
    }
    .msg {
      width: 1002px;
      height: 615px;
      margin: 100px auto;
      .leftMsg {
        width: 96px;
        height: 100%;
        float: left;
        .one {
          width: 96px;
          height: 96px;
          background: url("../assets/img/信息化建设/组 37@2x.png") center
            no-repeat;
          background-size: cover;
          margin-bottom: 37px;
        }
        .two {
          width: 48px;
          height: 59px;
          background: url("../assets/img/信息化建设/矩形 4@2x.png") center
            no-repeat;
          background-size: cover;
          margin-left: 24px;
          margin-bottom: 36px;
        }
        .three {
          width: 96px;
          height: 96px;
          background: url("../assets/img/信息化建设/组 37_1@2x.png") center
            no-repeat;
          background-size: cover;
          margin-bottom: 66px;
        }
        .four {
          width: 48px;
          height: 59px;
          background: url("../assets/img/信息化建设/矩形 4@2x.png") center
            no-repeat;
          background-size: cover;
          margin-left: 24px;
          margin-bottom: 65px;
        }
        .five {
          width: 96px;
          height: 96px;
          background: url("../assets/img/信息化建设/-e-组37.png") center
            no-repeat;
          background-size: cover;
        }
      }
      .rightMsg {
        width: 836px;
        height: 100%;
        line-height: 35px;
        float: right;
        .msone {
          width: 100%;
          height: 201px;
          overflow: hidden;
          margin-bottom: 15px;
        }
        .mstwo {
          width: 100%;
          height: 201px;
          overflow: hidden;
          margin-bottom: 110px;
        }
        .msthree {
          width: 100%;
          height: 201px;
          overflow: hidden;
        }
      }
    }
  }
}
h2 {
  opacity: 1;
  font-size: 22px;
  font-family: Microsoft YaHei Regular, Microsoft YaHei Regular-Regular;
  font-weight: 400;
  color: #1f89ec;
  margin: 0;
  margin-bottom: 20px;
}
</style>
